import { SCAN_WEBSITE, SUBMIT_REPORT, STORE_CONTACT } from "./constants";

const initialState = { 
  scanResultData:{},
  submitReportData:{},
  contactDetails:{},
}
  
const reducer = (state = initialState, action) => {
  const {
    type,
    payload
  } = action;

  switch (type) {
    case SCAN_WEBSITE: {
      return {
        ...state,
        scanResultData: payload,
      }
    }
    case SUBMIT_REPORT: {
      return {
        ...state,
        submitReportData: payload,
      }
    }
    case STORE_CONTACT: {
      return {
        ...state,
        contactDetails: payload,
      }
    }
    default:
      return state;
    }
}

export default reducer;